import React from 'react';
import Skeleton from 'src/Admin/components/common/skeleton';

const Lists = ({ data, selectChangeHandler, searchString }) => {
  const onChangeHandler = (e) => {
    selectChangeHandler(e);
  };

  return (
    <div className="blob-lists">
      {data ? (
        data
          .filter((d) => {
            if (!searchString) return true;
            if (
              d.BrokerName !== '' ||
              d.Code !== '' ||
              (d.TaxID && d.TaxID !== null)
            ) {
              if (
                d.BrokerName.toLowerCase().includes(
                  searchString.toLowerCase(),
                ) ||
                d.Code.toLowerCase().includes(searchString.toLowerCase()) ||
                (d.TaxID &&
                  d.TaxID.toLowerCase().includes(searchString.toLowerCase()))
              ) {
                return true;
              }
            }
          })
          .map((item, index) => {
            return (
              <div key={index}>
                <div className="blob-list-item-border">
                  <div className="d-flex broker-list-item">
                    <div className="d-flex">
                      <div className="d-flex mb-2">
                        <input
                          type="checkbox"
                          id={item.Code}
                          name={item.Code}
                          className="p-0 mt-auto mb-auto"
                          onChange={(e) => onChangeHandler(e)}
                          checked={item?.isChecked || false}
                        />
                      </div>
                      <div>
                        <div>
                          <span className="blob-item-name-1">
                            {item.BrokerName}
                          </span>
                        </div>
                        <div className="blob-item-desc-1">
                          Type: {item.BrokerTypeDesc}{' '}
                          {item.Parent && `| Parent : ${item.Parent}`}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="blob-item-desc-2">ID: {item.Code}</div>
                      {item.TaxID && (
                        <div className="blob-item-desc-3">
                          Tax: {item.TaxID}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
      ) : (
        <Skeleton count={20} height={30} />
      )}
    </div>
  );
};

export default Lists;
